import { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Box, Typography, useScrollTrigger } from '@mui/material';

import { AppRoutes } from '../../../constants/routes';
import headerLogo from '../../../assets/imgs/logo.png';
import { useNavContext } from '../../../providers/navigation/navigation.provider';

import CustomNavLink from '../nav-link/nav-link.component';
import MaxWidthContainer from '../../shared/max-width-containe/max-width-container.component';

import { useNavStyles } from './top-nav.styles';
import { body2 } from '../../../shared/theme/text.styles';
import { Menu } from '@mui/icons-material';

const TopNav = () => {
  const { toggleSideNav } = useNavContext();
  const classes = useNavStyles();
  const location = useLocation();
  const trigger = useScrollTrigger({ threshold: 0 });

  const isHomePage = location.pathname === AppRoutes.HOME.route;
  const setOpaque = useMemo(
    () => (isHomePage ? trigger : true),
    [trigger, isHomePage]
  );

  return (
    <>
      <nav
        className={`${classes.navWrapper} ${setOpaque ? classes.opaque : ''}`}
      >
        <MaxWidthContainer>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              height: '88px',
              borderBottom: '1px solid rgba(33,33,33,0.2)',
            }}
          >
            <Link style={{ color: '#212121' }} to={AppRoutes.HOME.route}>
              <Box display='flex' alignItems='center' justifyContent='center'>
                <Box className={classes.brandLogo}>
                  <img src={headerLogo} alt='fspl' className='img-logo' />
                </Box>
              </Box>
            </Link>

            <Box component='ul' className={classes.tnLinks}>
              <CustomNavLink
                style={{ color: '#212121' }}
                route={AppRoutes.WORKS}
              />
              <CustomNavLink
                style={{ color: '#212121' }}
                route={AppRoutes.JOBS}
              />
              <CustomNavLink
                style={{ color: '#212121' }}
                route={AppRoutes.ABOUT}
              />
              <CustomNavLink
                style={{ color: '#212121' }}
                route={AppRoutes.CONTACT_US}
              />
            </Box>
            <Menu
              style={{ color: '#212121' }}
              fontSize='36px'
              onClick={toggleSideNav}
              className={classes.tnMenu}
            />
          </Box>
        </MaxWidthContainer>
      </nav>
      <Box className={classes.navClearence} />
    </>
  );
};

export default TopNav;
